import React from "react"
import Helmet from "react-helmet"
import { Script } from "gatsby"

export default function CookieSolution() {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="//privacy-proxy.usercentrics.eu" />
        <link
          rel="preload"
          href="//privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js"
          as="script"
        />
      </Helmet>
      <Script
        type="application/javascript"
        src="https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js"
      ></Script>
      <Script
        id="usercentrics-cmp"
        src="https://app.usercentrics.eu/browser-ui/latest/loader.js"
        data-settings-id="RGvkllR8Vlgf2C"
        async
      ></Script>
    </>
  )
}
